module.exports = __webpack_public_path__ + "img/logo.c7ec7a73.png";